var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuoteAfterFilled = function SvgQuoteAfterFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 75 57"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M45 45.6c11.28-.48 15.36-5.28 15.36-14.4-12.24 0-19.2-6.96-19.2-16.08C41.16 6.48 47.64 0 57 0c10.08 0 18 7.44 18 24.48C75 44.64 63.48 56.4 46.92 56.4H45zM34.28 24.48c0 20.16-11.52 31.92-28.08 31.92H4.28V45.6c11.28-.48 15.36-5.28 15.36-14.4C7.4 31.2.44 24.24.44 15.12.44 6.48 6.92 0 16.04 0c10.08 0 18.24 7.44 18.24 24.48",
    opacity: 0.1
  })));
};
export default SvgQuoteAfterFilled;